export const fnMinIndex = (min, current) => current - 1 < min ? min : current - 1;